import update from 'immutability-helper'
import * as ActionTypes from '../../constants/design/MenuActionTypes'

const initialState = {
	types: [],
	menus: [],
  isEditableMenu: true,
	changed: false
}

export default (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.RECEIVE_ALL_DATA:
			return {
				types: action.types,
				menus: action.menus,
        isEditableMenu: action.isEditableMenu,
				changed: false
			}
		case ActionTypes.ADD_MENU:
			return update(state, {
				menus: {
					$push: [action.menu]
				},
				changed: {
					$set: true
				}
			})
		case ActionTypes.DELETE_MENU:
			return update(state, {
				menus: {
					$splice: [
						[action.index, 1]
					],
				},
				changed: {
					$set: true
				}
			})
		case ActionTypes.MOVE_MENU:
			const dragMenu = state.menus[action.dragIndex]

			return update(state, {
				menus: {
					$splice: [
						[action.dragIndex, 1],
						[action.hoverIndex, 0, update(dragMenu, {
							isTemporary: {
								$set: action.isTemporary
							}
						})],
					],
				}
			})
		case ActionTypes.DROP_MENU:
			return update(state, {
				menus: {
					[action.dragIndex]: {
						isTemporary: {
							$set: false
						}
					}
				},
				changed: {
					$set: true
				}
			})
		case ActionTypes.AFTER_SAVE:
			return update(state, {
				changed: {
					$set: false
				}
			})
		default :
			return state
	}
}
